<template>
    <footer class="bg-nomad-primary text-gray-100">
        <div class="mx-auto max-w-7xl px-6 py-12 lg:px-8">
            <div class="grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:items-start">
                <div class="flex flex-col items-start text-left">
                    <img src="/assets/logo-accent.svg" class="mb-6 h-16 w-auto" title="Nexa Interactives" alt="Nexa Interactives logo" />
                    <p class="text-sm leading-7 text-gray-300 lg:text-base">
                        At Nexa Interactives, we are passionate about crafting digital solutions that drive excellence.
                        With a team of seasoned web developers, designers, and tech enthusiasts, we specialize in turning ideas into impactful online experiences.
                    </p>
                </div>

                <div>
                    <h3 class="mb-5 text-lg font-semibold text-white">Explore</h3>
                    <ul class="space-y-3">
                        <li v-for="menu in menus" :key="menu.id">
                            <router-link :to="menu.url" class="text-base text-gray-100 transition-colors duration-200 hover:text-nomad-light">
                                {{ menu.text }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 class="mb-5 text-lg font-semibold text-white">Company</h3>
                    <ul class="space-y-3">
                        <li v-for="menu in menusSub" :key="menu.id">
                            <router-link :to="menu.url" class="text-base text-gray-100 transition-colors duration-200 hover:text-nomad-light">
                                {{ menu.text }}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div>
                    <h3 class="mb-5 text-lg font-semibold text-white">Contact</h3>
                    <ul class="space-y-4 text-sm text-gray-100 md:text-base">
                        <li class="flex items-start gap-3">
                            <span class="icon-phone mt-1 text-nomad-light"></span>
                            <span>(202) 670-1716</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="icon-mail mt-1 text-nomad-light"></span>
                            <span>support@nexainteractives.com</span>
                        </li>
                        <li class="flex items-start gap-3">
                            <span class="icon-map mt-1 text-nomad-light"></span>
                            <span>Annandale, VA<br>Virginia<br>Washington, DC<br>Maryland</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="border-t border-white/10 text-center text-sm text-gray-200 py-4">
            &copy; 2023 Nexa Interactives, all rights reserved.
        </div>
    </footer>
</template>
<script>
export default {
    data() {
        return {
            menus: [
                {
                    id: 1, 
                    text: 'Projects',
                    url: '/projects'
                },
                {
                    id: 2, 
                    text: 'Plans',
                    url: '/plans'
                },
                {
                    id: 3, 
                    text: 'Our Services',
                    url: '/projects'
                },
                {
                    id: 4, 
                    text: 'Hourly Subscriptions',
                    url: '/checkout'
                }
            ],
            menusSub: [
                {
                    id: 1, 
                    text: 'Contact us',
                    url: '/contact'
                },
                {
                    id: 2, 
                    text: 'About',
                    url: '/about'
                },
                {
                    id: 3, 
                    text: 'Terms & Conditions',
                    url: '/page/terms-conditions'
                },
                {
                    id: 4, 
                    text: 'Privacy Policy',
                    url: '/page/privacy'
                }
            ],
            
        }
    }
}
</script>